module.exports = __webpack_public_path__ + "static/media/gmail.ea34f09b.svg";